/* eslint-disable  */
import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { useAuth } from "./services/eqqo.auth.service";
import profileQuery from "./profile/profileQuery";
import respondentQuery from "./profile/respondentQuery";
import { useQuery } from "react-query";
import DownloadReportModal from "../pages/practitioner/components/DownloadReportModal";
import { pageContent } from "./services/eqqo.page.content";
// import { Modal } from "react-bootstrap";
// import { useNotifications } from "../components/NotificationsContext";
// import { useState } from "react";

const UserContext = createContext(null);

// eslint-disable-next-line react/prop-types
export const UserContextProvider = ({ children }) => {
	const { user } = useAuth();
	const { data: userProfile } = profileQuery(useQuery, user?.databaseId, { enabled: Boolean(user) });
	const { data: respondent, isLoading: respondentLoading } = respondentQuery(useQuery, user?.respondentId, { enabled: Boolean(user) });
	const { data: eqqoOptions } = useQuery(
		'eqqoOptions',
		() => fetch( process.env.REACT_APP_API_URL + '/wp-json/eqqo/v1/options' ).then( res => res.json() ),
		{ staleTime: 600000 }
	);

	const [showDownloadReport, setShowDownloadReport] = useState(false);
	const toggleDownloadReport = useCallback(() => {
		setShowDownloadReport((cur) => !cur);
	}, []);

	// I need to be able to update respondent from the Assessment component, but can't get useState to work here.
	// const [respondent, setRespondent] = useState(() => {
	// 	return respondentData;
	// });
	// Example of how to display notifications via UserContext
	// const [ modalOpen, setModalOpen ] = useState(false);
	// const { addNotification } = useNotifications();
	// const closeModal = useCallback(() => {
	// 	setModalOpen(false);
	// }, [setModalOpen]);

	// useEffect(() => {
	// 	setTimeout(() => {
	// 		addNotification({message:"test"});
	// 		setModalOpen(true);
	// 	}, 3500);
	// }, []);

	return (
		<UserContext.Provider value={{
			eqqoOptions,
			respondent,
			respondentLoading,
			toggleDownloadReport,
			user,
			userProfile,
		}}>
			{children}
			{/* <Modal show={modalOpen} onHide={closeModal} >
				<Modal.Header closeButton>
					Hey
				</Modal.Header>
				<Modal.Body>
					Are you still here?
				</Modal.Body>
			</Modal> */}

			<DownloadReportModal
				name={respondent?.name}
				onHide={toggleDownloadReport}
				profileId={user?.weqProfileId}
				show={showDownloadReport}
			/>
		</UserContext.Provider>
	);
};

export const useUser = () => useContext(UserContext);
